module.exports = __webpack_public_path__ + "img/la-banque-postale.ae2821e6.jpg";